import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";
import { ErrorMonitoringService } from "@/shared/services";

import { CreateDashboardRequest } from "../DashboardRecord";

import { dashboardQueryKeys } from "./dashboardQueryKeys";

export function useCreateDashboard() {
  const { dashboardService } = useDomainServices();
  const { currentOrganization } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateDashboardRequest) => {
      if (currentOrganization === null) {
        return Promise.reject(new Error("CurrentOrganization is not set"));
      }
      return dashboardService.createDashboard(
        request,
        currentOrganization.org_id,
      );
    },
    onSuccess: (record) => {
      queryClient.setQueryData(
        dashboardQueryKeys.id(record.dashboard_id, record.org_id),
        record,
      );
      void queryClient.invalidateQueries({
        queryKey: dashboardQueryKeys.lists(record.org_id),
      });
    },
    onError: (error) => {
      ErrorMonitoringService.captureError(error);
    },
  });
}
